import { queryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IProjectCRMAssociation } from 'views/DealDashboard/types';

const getCRMDealProjectsQueryOptions = (organizationId: string, dealId: number) => queryOptions({
    queryKey: ['CRMDealProjects', organizationId, dealId],
    queryFn: async () => {
        const response = await axiosInstance.get<IProjectCRMAssociation[]>(
            API_ENDPOINTS.CRM.DEAL_PROJECTS(organizationId, dealId),
        );
        return response.data;
    },
});

export default getCRMDealProjectsQueryOptions;
